import { useDispatch } from "react-redux";
import { useToast } from "../../../_helpers/notifications/useToasts";
import { ordersActions } from "../../../_store/order.slice";
import { orderViewsActions } from "../../../_store/orderView.slice";
import { PromptModal } from "../../../_components/Abstractions/PromptModal";

export function RefreshKeoEntriesForKpoCards({ orderId, orderNumber }) {
  const dispatch = useDispatch();
  const { showSuccessMessage, showErrorMessage } = useToast();

  async function onSubmit(promptResult) {
    if (promptResult !== "Yes") {
      return;
    }

    const response = await dispatch(ordersActions.refreshKeoEntriesForKpoCards({ orderId }));

    if (!response.error) {

      await dispatch(orderViewsActions.getBdoInfoById({ id: orderId }));
      await dispatch(orderViewsActions.refreshHistory({ id: orderId }));

      let successMessage = "Odświeżono wpisy KEO dla kart KPO";

      showSuccessMessage(successMessage);
    } else {
      showErrorMessage(response.error?.message);
    }
  }

  return (
    <>
      <PromptModal
        buttonText="Odśwież wpisy KEO dla kart KPO"
        title={`Czy odświeżyć wpisy KEO dla kart KPO dla zlecenia ${orderNumber}?`}
        type="YesNo"
        onSubmit={onSubmit}
      />
    </>
  );
}